export default {
  setAuthentication({commit}, payload) {
    commit('setAuthentication', payload);
  }
}
